import countries from './countries';
import underlyingList from './underlyingList';
// product.ProductId, product.IndexUniverseId, ProductIndexUniverseId, ProductName, MultipleFactor,ProductCategoryName, ProductTypeName, ProductSectorName, UnderlyingExposureText, IndexName,Sector, BloombergTotalReturn
const productList = [
  [
    '10001',
    '11248',
    '11238',
    'ETFS 3x Daily Long FTSE 100',
    '3',
    'UK',
    'Equity ETCs',
    '3X Leveraged Equity',
    'NULL',
    'FTSE 100 Net Dividend Total Return Index',
    'NULL',
    'UKXNUK Index',
  ],
  [
    '10003',
    '11250',
    '11240',
    'ETFS 3x Daily Long FTSE MIB',
    '3',
    'Italy',
    'Equity ETCs',
    '3X Leveraged Equity',
    'NULL',
    'FTSE  MIB Net Total Return Index',
    'NULL',
    'FTSEMIBN Index',
  ],
  [
    '10004',
    '11253',
    '11243',
    'ETFS 3x Daily Short EURO STOXX 50®',
    '3',
    'Europe',
    'Equity ETCs',
    '3X Leveraged Equity',
    'NULL',
    'ESTX 50 EUR (Gross Return)',
    'NULL',
    'SX5GT Index',
  ],
  [
    '10005',
    '11252',
    '11242',
    'ETFS 3x Daily Long EURO STOXX 50®',
    '3',
    'Europe',
    'Equity ETCs',
    '3X Leveraged Equity',
    'NULL',
    'ESTX 50 EUR (Net Return)',
    'NULL',
    'SX5T index',
  ],
  [
    '10006',
    '11254',
    '11245',
    'ETFS 3x Daily Short DAX 30',
    '3',
    'Germany',
    'Equity ETCs',
    '3X Leveraged Equity',
    'NULL',
    'DAX® (TR) EUR ',
    'NULL',
    'DAX Index',
  ],
  [
    '10007',
    '11254',
    '11244',
    'ETFS 3x Daily Long DAX 30',
    '3',
    'Germany',
    'Equity ETCs',
    '3X Leveraged Equity',
    'NULL',
    'DAX® (TR) EUR ',
    'NULL',
    'DAX Index',
  ],
  [
    '10009',
    '11255',
    '11246',
    'ETFS 3x Daily Long CAC 40',
    '3',
    'France',
    'Equity ETCs',
    '3X Leveraged Equity',
    'NULL',
    'CAC 40 NR',
    'NULL',
    'NCAC Index',
  ],
  [
    '10070',
    '11303',
    '11301',
    'ETFS 3x Daily Long FTSE China 50',
    '3',
    'Alternative',
    'Equity ETCs',
    '3X Leveraged Equity',
    'NULL',
    'FTSE China 50 Net Tax USD Index',
    'NULL',
    '',
  ],
  [
    '10115',
    '11343',
    '11342',
    'ETFS 2x Daily Long Low Sulphur Gas Oil',
    '2',
    'NULL',
    'NULL',
    'Agriculture',
    'NULL',
    'Bloomberg Gas Oil Subindex',
    'NULL',
    'NULL',
  ],
  [
    '2359',
    '11138',
    '11139',
    'ETFS 2x Daily Long Kansas Wheat',
    '2',
    'NULL',
    'NULL',
    'Agriculture',
    'NULL',
    'Bloomberg Kansas Wheat Subindex',
    'NULL',
    'NULL',
  ],
  [
    '2362',
    '11198',
    '11199',
    'ETFS 2x Daily Long Soybean Meal',
    '2',
    'NULL',
    'NULL',
    'Agriculture',
    'NULL',
    'Bloomberg Soybean Meal Subindex',
    'NULL',
    'NULL',
  ],
  [
    '2353',
    '11138',
    '11139',
    'ETFS 1x Daily Short Kansas Wheat',
    '-1',
    'NULL',
    'NULL',
    'Agriculture',
    'NULL',
    'Bloomberg Kansas Wheat Subindex',
    'NULL',
    'NULL',
  ],
  [
    '2356',
    '11198',
    '11199',
    'ETFS 1x Daily Short Soybean Meal',
    '-1',
    'NULL',
    'NULL',
    'Agriculture',
    'NULL',
    'Bloomberg Soybean Meal Subindex',
    'NULL',
    'NULL',
  ],
  [
    '10114',
    '11343',
    '11342',
    'ETFS 1x Daily Short Low Sulphur Gas Oil',
    '-1',
    'NULL',
    'NULL',
    'Agriculture',
    'NULL',
    'Bloomberg Gas Oil Subindex',
    'NULL',
    'NULL',
  ],
  [
    '10069',
    '11302',
    '11300',
    'ETFS 3x Daily Short FTSE China 50',
    '-3',
    'Alternative',
    'Equity ETCs',
    '3X Leveraged Equity',
    'NULL',
    'FTSE China 50 Index TR USD index',
    'NULL',
    '',
  ],
  [
    '10000',
    '11249',
    '11239',
    'ETFS 3x Daily Short FTSE 100',
    '-3',
    'UK',
    'Equity ETCs',
    '3X Leveraged Equity',
    'NULL',
    'FTSE 100 Total Return Declared Dividend Index',
    'NULL',
    'UKXDUK Index',
  ],
  [
    '10002',
    '11251',
    '11241',
    'ETFS 3x Daily Short FTSE MIB',
    '-3',
    'Italy',
    'Equity ETCs',
    '3X Leveraged Equity',
    'NULL',
    'FTSE MIB Total Return Index',
    'NULL',
    'TFTSEMIB Index',
  ],
  [
    '10008',
    '11256',
    '11247',
    'ETFS 3x Daily Short CAC 40',
    '-3',
    'France',
    'Equity ETCs',
    '3X Leveraged Equity',
    'NULL',
    'CAC 40 GR',
    'NULL',
    'CACR Index',
  ],
  [
    '1939',
    '1053',
    '1065',
    'ETFS 2x Daily Long Agriculture',
    '2',
    'Agriculture',
    'Commodity ETCs',
    'Agriculture',
    'Agriculture',
    'Bloomberg Agriculture Subindex',
    'Agriculture',
    'BCOMAG',
  ],
  [
    '2022',
    '1053',
    '1065',
    'ETFS 1x Daily Short Agriculture',
    '-1',
    'Agriculture',
    'Commodity ETCs',
    'Agriculture',
    'Agriculture',
    'Bloomberg Agriculture Subindex',
    'Agriculture',
    'BCOMAG',
  ],
  [
    '1941',
    '1001',
    '1002',
    'ETFS 2x Daily Long Aluminium',
    '2',
    'Aluminium',
    'Commodity ETCs',
    'Industrial Metals',
    'Aluminium',
    'Bloomberg Aluminum Subindex',
    'Industrial Metals',
    'BCOMAL',
  ],
  [
    '2024',
    '1001',
    '1002',
    'ETFS 1x Daily Short Aluminium',
    '-1',
    'Aluminium',
    'Commodity ETCs',
    'Industrial Metals',
    'Aluminium',
    'Bloomberg Aluminum Subindex',
    'Industrial Metals',
    'BCOMAL',
  ],
  [
    '10021',
    '11268',
    '11268',
    'ETFS 5x Long AUD Short EUR',
    '5',
    '5* Long vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'AUDEUR',
    'MSFXSM 5X Long Australian Dollar/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEAXL',
  ],
  [
    '2164',
    '816',
    '816',
    'ETFS 3x Long AUD Short EUR',
    '3',
    '3* Long vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'AUDEUR',
    'MSFXSM Triple Long Australian Dollar/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEAUL',
  ],
  [
    '2149',
    '839',
    '839',
    'ETFS 3x Long AUD Short GBP',
    '3',
    '3* Long vs. GBP',
    'GBP Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'AUDGBP',
    'MSFXSM Triple Long Australian Dollar/GBP Index (TR)',
    'ExposureShariah',
    'MSCEGAUL',
  ],
  [
    '2141',
    '891',
    '891',
    'ETFS 3x Long AUD Short USD',
    '3',
    '3* Long vs. USD',
    'USD Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'AUDUSD',
    'MSFXSM Triple Long Australian Dollar Index (TR)',
    'ExposureShariah',
    'MSCEAUUL',
  ],
  [
    '75',
    '32',
    'NULL',
    'Boost Brent Oil 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Brent',
    'NASDAQ Commodity Brent Crude Oil ER',
    'NULL',
    'NULL',
  ],
  [
    '76',
    '32',
    'NULL',
    'Boost Brent Oil 3x Short Daily ETP',
    '-3',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Brent',
    'NASDAQ Commodity Brent Crude Oil ER',
    'NULL',
    'NULL',
  ],
  [
    '55',
    '25',
    'NULL',
    'Boost BTP 10Y 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Fixed Income ETCs',
    'Other Sectors',
    'BTPs',
    'Long Term BTP Rolling Future',
    'NULL',
    'NULL',
  ],
  [
    '39',
    '25',
    'NULL',
    'Boost BTP 10Y 3x Short Daily ETP',
    '-3',
    'NULL',
    'Fixed Income ETCs',
    'Other Sectors',
    'BTPs',
    'Long Term BTP Rolling Future',
    'NULL',
    'NULL',
  ],
  [
    '71',
    '25',
    'NULL',
    'Boost BTP 10Y 5x Short Daily ETP',
    '-5',
    'NULL',
    'Fixed Income ETCs',
    'Other Sectors',
    'BTPs',
    'Long Term BTP Rolling Future',
    'NULL',
    'NULL',
  ],
  [
    '54',
    '26',
    'NULL',
    'Boost Bund 10Y 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Fixed Income ETCs',
    'Other Sectors',
    'Bund 10Y',
    'Bund Rolling Future',
    'NULL',
    'NULL',
  ],
  [
    '40',
    '26',
    'NULL',
    'Boost Bund 10Y 3x Short Daily ETP',
    '-3',
    'NULL',
    'Fixed Income ETCs',
    'Other Sectors',
    'Bund 10Y',
    'Bund Rolling Future',
    'NULL',
    'NULL',
  ],
  [
    '72',
    '26',
    'NULL',
    'Boost Bund 10Y 5x Short Daily ETP',
    '-5',
    'NULL',
    'Fixed Income ETCs',
    'Other Sectors',
    'Bund 10Y',
    'Bund Rolling Future',
    'NULL',
    'NULL',
  ],
  [
    '111',
    '67',
    'NULL',
    'Boost Bund 30Y 3x Short Daily ETP',
    '-3',
    'NULL',
    'Fixed Income ETCs',
    'Other Sectors',
    'Bunds 30Y',
    'BNP Paribas Long Bund 30Y Rolling Future',
    'NULL',
    'NULL',
  ],
  [
    '10023',
    '11270',
    '11270',
    'ETFS 5x Long CAD Short EUR',
    '5',
    '5* Long vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'CADEUR',
    'MSFXSM 5X Long Canadian Dollar/Euro Index (TR)',
    'ExposureShariah',
    'MSCEECXL',
  ],
  [
    '2165',
    '818',
    '818',
    'ETFS 3x Long CAD Short EUR',
    '3',
    '3* Long vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'CADEUR',
    'MSFXSM Triple Long Canadian Dollar/Euro Index (TR)',
    'ExposureShariah',
    'MSCEECUL',
  ],
  [
    '10025',
    '11272',
    '11272',
    'ETFS 5x Long CHF Short EUR',
    '5',
    '5* Long vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'CHFEUR',
    'MSFXSM 5X Long Swiss Franc/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEHXL',
  ],
  [
    '2166',
    '820',
    '820',
    'ETFS 3x Long CHF Short EUR',
    '3',
    '3* Long vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'CHFEUR',
    'MSFXSM Triple Long Swiss Franc/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEHUL',
  ],
  [
    '10049',
    '11273',
    '11273',
    'ETFS 5x Short CHF Long EUR',
    '-5',
    '5* Short vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'CHFEUR',
    'MSFXSM 5X Short Swiss Franc/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEHXS',
  ],
  [
    '1942',
    '1003',
    '1004',
    'ETFS 2x Daily Long Cocoa',
    '2',
    'Cocoa',
    'Commodity ETCs',
    'Agriculture',
    'Cocoa',
    'Bloomberg Cocoa Subindex',
    'Agriculture',
    'BCOMCC',
  ],
  [
    '2035',
    '1003',
    '1004',
    'ETFS 1x Daily Short Cocoa',
    '-1',
    'Cocoa',
    'Commodity ETCs',
    'Agriculture',
    'Cocoa',
    'Bloomberg Cocoa Subindex',
    'Agriculture',
    'BCOMCC',
  ],
  [
    '10052',
    '1005',
    '1006',
    'ETFS 3x Daily Long Coffee',
    '3',
    'Coffee',
    'Commodity ETCs',
    'Agriculture',
    'Coffee',
    'Bloomberg Coffee Subindex',
    'NULL',
    'BCOMKC',
  ],
  [
    '1943',
    '1005',
    '1006',
    'ETFS 2x Daily Long Coffee',
    '2',
    'Coffee',
    'Commodity ETCs',
    'Agriculture',
    'Coffee',
    'Bloomberg Coffee Subindex',
    'Agriculture',
    'BCOMKC',
  ],
  [
    '2036',
    '1005',
    '1006',
    'ETFS 1x Daily Short Coffee',
    '-1',
    'Coffee',
    'Commodity ETCs',
    'Agriculture',
    'Coffee',
    'Bloomberg Coffee Subindex',
    'Agriculture',
    'BCOMKC',
  ],
  [
    '10051',
    '1005',
    '1006',
    'ETFS 3x Daily Short Coffee',
    '-3',
    'Coffee',
    'Commodity ETCs',
    'Agriculture',
    'Coffee',
    'Bloomberg Coffee Subindex',
    'NULL',
    'BCOMKC',
  ],
  [
    '10054',
    '1007',
    '1008',
    'ETFS 3x Daily Long Copper',
    '3',
    'Copper',
    'Commodity ETCs',
    'Industrial Metals',
    'Copper',
    'Bloomberg Copper Subindex',
    'NULL',
    'BCOMHG',
  ],
  [
    '13',
    '13',
    'NULL',
    'Boost Copper 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Copper',
    'NASDAQ Commodity HG Copper ER',
    'NULL',
    'NULL',
  ],
  [
    '1944',
    '1007',
    '1008',
    'ETFS 2x Daily Long Copper',
    '2',
    'Copper',
    'Commodity ETCs',
    'Industrial Metals',
    'Copper',
    'Bloomberg Copper Subindex',
    'Agriculture',
    'BCOMHG',
  ],
  [
    '2037',
    '1007',
    '1008',
    'ETFS 1x Daily Short Copper',
    '-1',
    'Copper',
    'Commodity ETCs',
    'Industrial Metals',
    'Copper',
    'Bloomberg Copper Subindex',
    'Agriculture',
    'BCOMHG',
  ],
  [
    '14',
    '13',
    'NULL',
    'Boost Copper 3x Short Daily ETP',
    '-3',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Copper',
    'NASDAQ Commodity HG Copper ER',
    'NULL',
    'NULL',
  ],
  [
    '10053',
    '1007',
    '1008',
    'ETFS 3x Daily Short Copper',
    '-3',
    'Copper',
    'Commodity ETCs',
    'Industrial Metals',
    'Copper',
    'Bloomberg Copper Subindex',
    'NULL',
    'BCOMHG',
  ],
  [
    '1945',
    '1009',
    '1010',
    'ETFS 2x Daily Long Corn',
    '2',
    'Corn',
    'Commodity ETCs',
    'Agriculture',
    'Corn',
    'Bloomberg Corn Subindex',
    'Agriculture',
    'BCOMCN',
  ],
  [
    '2038',
    '1009',
    '1010',
    'ETFS 1x Daily Short Corn',
    '-1',
    'Corn',
    'Commodity ETCs',
    'Agriculture',
    'Corn',
    'Bloomberg Corn Subindex',
    'Agriculture',
    'BCOMCN',
  ],
  [
    '1946',
    '1011',
    '1012',
    'ETFS 2x Daily Long Cotton',
    '2',
    'Cotton',
    'Commodity ETCs',
    'Agriculture',
    'Cotton',
    'Bloomberg Cotton Subindex',
    'Agriculture',
    'BCOMCT',
  ],
  [
    '2039',
    '1011',
    '1012',
    'ETFS 1x Daily Short Cotton',
    '-1',
    'Cotton',
    'Commodity ETCs',
    'Agriculture',
    'Cotton',
    'Bloomberg Cotton Subindex',
    'Agriculture',
    'BCOMCT',
  ],
  [
    '17',
    '11',
    'NULL',
    'Boost WTI Oil 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Crude Oil',
    'NASDAQ Commodity Crude Oil ER',
    'NULL',
    'NULL',
  ],
  [
    '57',
    '11',
    'NULL',
    'Boost WTI Oil 2x Leverage Daily ETP',
    '2',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Crude Oil',
    'NASDAQ Commodity Crude Oil ER',
    'NULL',
    'NULL',
  ],
  [
    '59',
    '11',
    'NULL',
    'Boost WTI Oil 1x Short Daily ETP',
    '-1',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Crude Oil',
    'NASDAQ Commodity Crude Oil ER',
    'NULL',
    'NULL',
  ],
  [
    '58',
    '11',
    'NULL',
    'Boost WTI Oil 2x Short Daily ETP',
    '-2',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Crude Oil',
    'NASDAQ Commodity Crude Oil ER',
    'NULL',
    'NULL',
  ],
  [
    '18',
    '11',
    'NULL',
    'Boost WTI Oil 3x Short Daily ETP',
    '-3',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Crude Oil',
    'NASDAQ Commodity Crude Oil ER',
    'NULL',
    'NULL',
  ],
  [
    '10089',
    '1135',
    '1211',
    'ETFS 2x Daily Long Brent Crude',
    '2',
    'Oil',
    'Commodity ETCs',
    'Energy',
    'Crude Oil (Brent)',
    'Bloomberg Brent Crude Subindex',
    'Energy',
    'BCOMCO',
  ],
  [
    '2203',
    '1135',
    '1211',
    'ETFS 1x Daily Short Brent Crude',
    '-1',
    'Oil',
    'Commodity ETCs',
    'Energy',
    'Crude Oil (Brent)',
    'Bloomberg Brent Crude Subindex',
    'Energy',
    'BCOMCO',
  ],
  [
    '10068',
    '1013',
    '1014',
    'ETFS 3x Daily Long WTI Crude Oil',
    '3',
    'Oil',
    'Commodity ETCs',
    'Energy',
    'Crude Oil (WTI)',
    'Bloomberg WTI Crude Oil Subindex',
    'NULL',
    'BCOMCL',
  ],
  [
    '10084',
    '1013',
    '1014',
    'ETFS 2x Daily Long WTI Crude Oil',
    '2',
    'Oil',
    'Commodity ETCs',
    'Energy',
    'Crude Oil (WTI)',
    'Bloomberg WTI Crude Oil Subindex',
    'Energy',
    'BCOMCL',
  ],
  [
    '2040',
    '1013',
    '1014',
    'ETFS 1x Daily Short WTI Crude Oil',
    '-1',
    'Oil',
    'Commodity ETCs',
    'Energy',
    'Crude Oil (WTI)',
    'Bloomberg WTI Crude Oil Subindex',
    'Energy',
    'BCOMCL',
  ],
  [
    '10067',
    '1013',
    '1014',
    'ETFS 3x Daily Short WTI Crude Oil',
    '-3',
    'Oil',
    'Commodity ETCs',
    'Energy',
    'Crude Oil (WTI)',
    'Bloomberg WTI Crude Oil Subindex',
    'NULL',
    'BCOMCL',
  ],
  [
    '7',
    '5',
    'NULL',
    'Boost LevDAX 3x Daily ETP',
    '3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'DAX',
    'LevDAX x3 TR',
    'NULL',
    'NULL',
  ],
  [
    '8',
    '6',
    'NULL',
    'Boost ShortDAX 3x Daily ETP',
    '-3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'DAX',
    'ShortDAX x3 TR',
    'NULL',
    'NULL',
  ],
  [
    '1940',
    '1047',
    '1059',
    'ETFS 2x Daily Long All Commodities',
    '2',
    'All commodities',
    'Commodity ETCs',
    'Diversified Commodities',
    'Diversified Broad Commodities',
    'Bloomberg Commodity Index',
    'Broad Commodities',
    'BCOM',
  ],
  [
    '2023',
    '1047',
    '1059',
    'ETFS 1x Daily Short All Commodities',
    '-1',
    'All commodities',
    'Commodity ETCs',
    'Diversified Commodities',
    'Diversified Broad Commodities',
    'Bloomberg Commodity Index',
    'Broad Commodities',
    'BCOM',
  ],
  [
    '1949',
    '1052',
    '920',
    'ETFS 2x Daily Long Ex-Energy',
    '2',
    'Ex-Energy',
    'Commodity ETCs',
    'Diversified Commodities',
    'Diversified Broad Commodities ex Energy',
    'Bloomberg ExEnergy Subindex',
    'Broad Commodities',
    'BCOMXE',
  ],
  [
    '2044',
    '1052',
    '920',
    'ETFS 1x Daily Short Ex-Energy',
    '-1',
    'Ex-Energy',
    'Commodity ETCs',
    'Diversified Commodities',
    'Diversified Broad Commodities ex Energy',
    'Bloomberg ExEnergy Subindex',
    'Broad Commodities',
    'BCOMXE',
  ],
  [
    '87',
    '33',
    'NULL',
    'Boost Emerging Markets 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'Emerging Markets',
    'Emerging Equities Rolling Futures',
    'NULL',
    'NULL',
  ],
  [
    '88',
    '33',
    'NULL',
    'Boost Emerging Markets 3x Short Daily ETP',
    '-3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'Emerging Markets',
    'Emerging Equities Rolling Futures',
    'NULL',
    'NULL',
  ],
  [
    '1948',
    '1050',
    '1062',
    'ETFS 2x Daily Long Energy',
    '2',
    'Diversified',
    'Commodity ETCs',
    'Energy',
    'Energy',
    'Bloomberg Energy Subindex',
    'Energy',
    'BCOMEN',
  ],
  [
    '2041',
    '1050',
    '1062',
    'ETFS 1x Daily Short Energy',
    '-1',
    'Diversified',
    'Commodity ETCs',
    'Energy',
    'Energy',
    'Bloomberg Energy Subindex',
    'Energy',
    'BCOMEN',
  ],
  [
    '2170',
    '822',
    '822',
    'ETFS 3x Short AUD Long EUR',
    '-3',
    '3* Short vs. EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'EURAUD',
    'MSFXSM Triple Short Australian Dollar/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEAUS',
  ],
  [
    '10022',
    '11269',
    '11269',
    'ETFS 5x Short AUD Long EUR',
    '-5',
    '5* Short vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'EURAUD',
    'MSFXSM 5X Short Australian Dollar/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEAXS',
  ],
  [
    '2171',
    '824',
    '824',
    'ETFS 3x Short CAD Long EUR',
    '-3',
    '3* Short vs. EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'EURCAD',
    'MSFXSM Triple Short Canadian Dollar/Euro Index (TR)',
    'ExposureShariah',
    'MSCEECUS',
  ],
  [
    '10024',
    '11271',
    '11271',
    'ETFS 5x Short CAD Long EUR',
    '-5',
    '5* Short vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'EURCAD',
    'MSFXSM 5X Short Canadian Dollar/Euro Index (TR)',
    'ExposureShariah',
    'MSCEECXS',
  ],
  [
    '2172',
    '826',
    '826',
    'ETFS 3x Short CHF Long EUR',
    '-3',
    '3* Short vs. EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'EURCHF',
    'MSFXSM Triple Short Swiss Franc/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEHUS',
  ],
  [
    '10073',
    '11306',
    '11306',
    'ETFS 5x Long EUR Short GBP',
    '5',
    '5* Long EUR vs. GBP',
    'Long currency ETCs',
    'Leveraged (x5) and Short (x5) Currency Indices',
    'EURGBP',
    'MSFX 5x Long Euro/British Pound Index (TR)',
    'NULL',
    'MSCEGEXL',
  ],
  [
    '2152',
    '838',
    '838',
    'ETFS 3x Long EUR Short GBP',
    '3',
    '3* Long vs. GBP',
    'GBP Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'EURGBP',
    'MSFXSM Triple Long Euro/GBP Index (TR)',
    'ExposureShariah',
    'MSCEGEUL',
  ],
  [
    '2173',
    '823',
    '823',
    'ETFS 3x Short GBP Long EUR',
    '-3',
    '3* Short vs. EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'EURGBP',
    'MSFXSM Triple Short British Pound/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEGUS',
  ],
  [
    '10074',
    '11307',
    '11307',
    'ETFS 5x Short EUR Long GBP',
    '-5',
    '5* Short EUR vs. GBP',
    'Short currency ETCs',
    'Leveraged (x5) and Short (x5) Currency Indices',
    'EURGBP',
    'MSFX 5x Short Euro/British Pound Index (TR)',
    'NULL',
    'MSCEGEXS',
  ],
  [
    '10030',
    '11277',
    '11277',
    'ETFS 5x Short GBP Long EUR',
    '-5',
    '5* Short vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'EURGBP',
    'MSFXSM 5X Short British Pound/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEGXS',
  ],
  [
    '2174',
    '825',
    '825',
    'ETFS 3x Short JPY Long EUR',
    '-3',
    '3* Short vs. EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'EURJPP',
    'MSFXSM Triple Short Japanese Yen/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEJUS',
  ],
  [
    '10032',
    '11279',
    '11279',
    'ETFS 5x Short JPY Long EUR',
    '-5',
    '5* Short vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'EURJPY',
    'MSFXSM 5X Short Japanese Yen/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEJXS',
  ],
  [
    '10071',
    '11304',
    '11304',
    'ETFS 5x Long EUR Short USD',
    '5',
    '5* Long EUR vs. USD',
    'Long currency ETCs',
    'Leveraged (x5) and Short (x5) Currency Indices',
    'EURUSD',
    'MSFX 5x Long Euro/US Dollar Index (TR)',
    'NULL',
    'MSCEERXL',
  ],
  [
    '2144',
    '893',
    '893',
    'ETFS 3x Long EUR Short USD',
    '3',
    '3* Long vs. USD',
    'USD Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'EURUSD',
    'MSFXSM Triple Long Euro Index (TR)',
    'ExposureShariah',
    'MSCEERUL',
  ],
  [
    '2175',
    '827',
    '827',
    'ETFS 3x Short USD Long EUR',
    '-3',
    '3* Short vs. EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'EURUSD',
    'MSFXSM Triple Short US Dollar/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEUUS',
  ],
  [
    '10072',
    '11305',
    '11305',
    'ETFS 5x Short EUR Long USD',
    '-5',
    '5* Short EUR vs. USD',
    'Short currency ETCs',
    'Leveraged (x5) and Short (x5) Currency Indices',
    'EURUSD',
    'MSFX 5x Short Euro/US Dollar Index (TR)',
    'NULL',
    'MSCEERXS',
  ],
  [
    '10028',
    '11275',
    '11275',
    'ETFS 5x Short USD Long EUR',
    '-5',
    '5* Short vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'EURUSD',
    'MSFXSM 5X Short US Dollar/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEUXS',
  ],
  [
    '9',
    '3',
    'NULL',
    'Boost EURO STOXX 50 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'EURO STOXX 50',
    'EURO STOXX 50 Daily Leverage 3 EUR Net Return',
    'NULL',
    'NULL',
  ],
  [
    '10',
    '4',
    'NULL',
    'Boost EURO STOXX 50 3x Short Daily ETP',
    '-3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'EURO STOXX 50',
    'EURO STOXX 50 Daily Short 3 EUR Gross Return',
    'NULL',
    'NULL',
  ],
  [
    '49',
    '29',
    'NULL',
    'Boost EURO STOXX Banks 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'Euro STOXX Banks',
    'EURO STOXX Banks Daily Leverage 3 EUR Net Return',
    'NULL',
    'NULL',
  ],
  [
    '50',
    '30',
    'NULL',
    'Boost EURO STOXX Banks 3x Short Daily ETP',
    '-3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'Euro STOXX Banks',
    'EURO STOXX Banks Daily Short 3 EUR Gross Return',
    'NULL',
    'NULL',
  ],
  [
    '51',
    '31',
    'NULL',
    'Boost Long USD Short EUR 5x Daily ETP',
    '5',
    'NULL',
    'Short currency ETCs',
    'Other Sectors',
    'EURUSD',
    'BNP Paribas USD EUR FX Spot',
    'NULL',
    'NULL',
  ],
  [
    '70',
    '31',
    'NULL',
    'Boost Long USD Short EUR 4x Daily ETP',
    '4',
    'NULL',
    'Short currency ETCs',
    'Other Sectors',
    'EURUSD',
    'BNP Paribas USD EUR FX Spot',
    'NULL',
    'NULL',
  ],
  [
    '69',
    '31',
    'NULL',
    'Boost Short USD Long EUR 4x Daily ETP',
    '-4',
    'NULL',
    'Long currency ETCs',
    'Other Sectors',
    'EURUSD',
    'BNP Paribas USD EUR FX Spot',
    'NULL',
    'NULL',
  ],
  [
    '52',
    '31',
    'NULL',
    'Boost Short USD Long EUR 5x Daily ETP',
    '-5',
    'NULL',
    'Long currency ETCs',
    'Other Sectors',
    'EURUSD',
    'BNP Paribas USD EUR FX Spot',
    'NULL',
    'NULL',
  ],
  [
    '1',
    '1',
    'NULL',
    'Boost FTSE 100 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'FTSE 100',
    'FTSE 100 Daily Super Leveraged RT TR',
    'NULL',
    'NULL',
  ],
  [
    '34',
    '18',
    'NULL',
    'Boost FTSE 100 2x Leverage Daily ETP',
    '2',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'FTSE 100',
    'FTSE 100 Daily Leveraged RT TR',
    'NULL',
    'NULL',
  ],
  [
    '36',
    '17',
    'NULL',
    'Boost FTSE 100 1x Short Daily ETP',
    '-1',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'FTSE 100',
    'FTSE 100 Daily Short Strategy RT Gross TR',
    'NULL',
    'NULL',
  ],
  [
    '35',
    '16',
    'NULL',
    'Boost FTSE 100 2x Short Daily ETP',
    '-2',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'FTSE 100',
    'FTSE 100 Daily Super Short Strategy RT Gross TR',
    'NULL',
    'NULL',
  ],
  [
    '2',
    '2',
    'NULL',
    'Boost FTSE 100 3x Short Daily ETP',
    '-3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'FTSE 100',
    'FTSE 100 Daily Ultra Short Strategy RT Gross TR',
    'NULL',
    'NULL',
  ],
  [
    '29',
    '20',
    'NULL',
    'Boost FTSE 250 2x Leverage Daily ETP',
    '2',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'FTSE 250',
    'FTSE 250 Daily Leveraged RT TR',
    'NULL',
    'NULL',
  ],
  [
    '24',
    '19',
    'NULL',
    'Boost FTSE 250 1x Short Daily ETP',
    '-1',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'FTSE 250',
    'FTSE 250 Daily Short Strategy RT Gross TR',
    'NULL',
    'NULL',
  ],
  [
    '37',
    '24',
    'NULL',
    'Boost FTSE MIB 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'FTSE MIB',
    'FTSE MIB Super Leveraged RT Net-of-Tax Lux TR',
    'NULL',
    'NULL',
  ],
  [
    '38',
    '23',
    'NULL',
    'Boost FTSE MIB 3x Short Daily ETP',
    '-3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'FTSE MIB',
    'FTSE MIB Ultra Short Strategy RT GR',
    'NULL',
    'NULL',
  ],
  [
    '2153',
    '835',
    '835',
    'ETFS 3x Short AUD Long GBP',
    '-3',
    '3* Short vs. GBP',
    'GBP Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'GBPAUD',
    'MSFXSM Triple Short Australian Dollar/GBP Index (TR)',
    'ExposureShariah',
    'MSCEGAUS',
  ],
  [
    '10029',
    '11276',
    '11276',
    'ETFS 5x Long GBP Short EUR',
    '5',
    '5* Long vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'GBPEUR',
    'MSFXSM 5X Long British Pound/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEGXL',
  ],
  [
    '2167',
    '817',
    '817',
    'ETFS 3x Long GBP Short EUR',
    '3',
    '3* Long vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'GBPEUR',
    'MSFXSM Triple Long British Pound/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEGUL',
  ],
  [
    '2156',
    '834',
    '834',
    'ETFS 3x Short EUR Long GBP',
    '-3',
    '3* Short vs. GBP',
    'GBP Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'GBPEUR',
    'MSFXSM Triple Short Euro/GBP Index (TR)',
    'ExposureShariah',
    'MSCEGEUS',
  ],
  [
    '2155',
    '833',
    '833',
    'ETFS 3x Short JPY Long GBP',
    '-3',
    '3* Short vs. GBP',
    'GBP Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'GBPJPY',
    'MSFXSM Triple Short Japanese Yen/GBP Index (TR)',
    'ExposureShariah',
    'MSCEGJUS',
  ],
  [
    '2142',
    '892',
    '892',
    'ETFS 3x Long GBP Short USD',
    '3',
    '3* Long vs. USD',
    'USD Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'GBPUSD',
    'MSFXSM Triple Long British Pound Index (TR)',
    'ExposureShariah',
    'MSCEGBUL',
  ],
  [
    '2154',
    '832',
    '832',
    'ETFS 3x Short USD Long GBP',
    '-3',
    '3* Short vs. GBP',
    'GBP Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'GBPUSD',
    'MSFXSM Triple Short US Dollar/GBP Index (TR)',
    'ExposureShariah',
    'MSCEGUUS',
  ],
  [
    '48',
    '27',
    'NULL',
    'Boost Gilts 10Y 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Fixed Income ETCs',
    'Other Sectors',
    'Gilts',
    'Long Gilt Rolling Future',
    'NULL',
    'NULL',
  ],
  [
    '112',
    '27',
    'NULL',
    'Boost Gilts 10Y 1x Short Daily ETP',
    '-1',
    'NULL',
    'Fixed Income ETCs',
    'Other Sectors',
    'Gilts',
    'Long Gilt Rolling Future',
    'NULL',
    'NULL',
  ],
  [
    '42',
    '27',
    'NULL',
    'Boost Gilts 10Y 3x Short Daily ETP',
    '-3',
    'NULL',
    'Fixed Income ETCs',
    'Other Sectors',
    'Gilts',
    'Long Gilt Rolling Future',
    'NULL',
    'NULL',
  ],
  [
    '11',
    '12',
    'NULL',
    'Boost Gold 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Gold',
    'NASDAQ Commodity Gold ER',
    'NULL',
    'NULL',
  ],
  [
    '10056',
    '1015',
    '1016',
    'ETFS 3x Daily Long Gold',
    '3',
    'Gold',
    'Commodity ETCs',
    'Precious Metals',
    'Gold',
    'Bloomberg Gold Subindex',
    'NULL',
    'BCOMGC',
  ],
  [
    '26',
    '12',
    'NULL',
    'Boost Gold 2x Leverage Daily ETP',
    '2',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Gold',
    'NASDAQ Commodity Gold ER',
    'NULL',
    'NULL',
  ],
  [
    '1951',
    '1015',
    '1016',
    'ETFS 2x Daily Long Gold',
    '2',
    'Gold',
    'Commodity ETCs',
    'Precious Metals',
    'Gold',
    'Bloomberg Gold Subindex',
    'Livestock',
    'BCOMGC',
  ],
  [
    '2048',
    '1015',
    '1016',
    'ETFS 1x Daily Short Gold',
    '-1',
    'Gold',
    'Commodity ETCs',
    'Precious Metals',
    'Gold',
    'Bloomberg Gold Subindex',
    'Livestock',
    'BCOMGC',
  ],
  [
    '22',
    '12',
    'NULL',
    'Boost Gold 1x Short Daily ETP',
    '-1',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Gold',
    'NASDAQ Commodity Gold ER',
    'NULL',
    'NULL',
  ],
  [
    '27',
    '12',
    'NULL',
    'Boost Gold 2x Short Daily ETP',
    '-2',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Gold',
    'NASDAQ Commodity Gold ER',
    'NULL',
    'NULL',
  ],
  [
    '12',
    '12',
    'NULL',
    'Boost Gold 3x Short Daily ETP',
    '-3',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Gold',
    'NASDAQ Commodity Gold ER',
    'NULL',
    'NULL',
  ],
  [
    '10055',
    '1015',
    '1016',
    'ETFS 3x Daily Short Gold',
    '-3',
    'Gold',
    'Commodity ETCs',
    'Precious Metals',
    'Gold',
    'Bloomberg Gold Subindex',
    'NULL',
    'BCOMGC',
  ],
  [
    '1952',
    '1054',
    '1066',
    'ETFS 2x Daily Long Grains',
    '2',
    'Grains',
    'Commodity ETCs',
    'Agriculture',
    'Grains',
    'Bloomberg Grains Subindex',
    'Agriculture',
    'BCOMGR',
  ],
  [
    '2049',
    '1054',
    '1066',
    'ETFS 1x Daily Short Grains',
    '-1',
    'Grains',
    'Commodity ETCs',
    'Agriculture',
    'Grains',
    'Bloomberg Grains Subindex',
    'Agriculture',
    'BCOMGR',
  ],
  [
    '1953',
    '1017',
    '1018',
    'ETFS 2x Daily Long Heating Oil',
    '2',
    'Refined Products',
    'Commodity ETCs',
    'Energy',
    'Heating Oil',
    'Bloomberg Heating Oil Subindex',
    'Energy',
    'BCOMHO',
  ],
  [
    '2050',
    '1017',
    '1018',
    'ETFS 1x Daily Short Heating Oil',
    '-1',
    'Refined Products',
    'Commodity ETCs',
    'Energy',
    'Heating Oil',
    'Bloomberg Heating Oil Subindex',
    'Energy',
    'BCOMHO',
  ],
  [
    '1954',
    '1057',
    '1069',
    'ETFS 2x Daily Long Industrial Metal',
    '2',
    'Industrial Metals',
    'Commodity ETCs',
    'Industrial Metals',
    'Industrial Metals',
    'Bloomberg Industrial Metals Subindex',
    'Industrial Metals',
    'BCOMIN',
  ],
  [
    '2051',
    '1057',
    '1069',
    'ETFS 1x Daily Short Industrial Metals',
    '-1',
    'Industrial Metals',
    'Commodity ETCs',
    'Industrial Metals',
    'Industrial Metals',
    'Bloomberg Industrial Metals Subindex',
    'Industrial Metals',
    'BCOMIN',
  ],
  [
    '10031',
    '11278',
    '11278',
    'ETFS 5x Long JPY Short EUR',
    '5',
    '5* Long vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'JPYEUR',
    'MSFXSM 5X Long Japanese Yen/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEJXL',
  ],
  [
    '2168',
    '819',
    '819',
    'ETFS 3x Long JPY Short EUR',
    '3',
    '3* Long vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'JPYEUR',
    'MSFXSM Triple Long Japanese Yen/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEJUL',
  ],
  [
    '2151',
    '837',
    '837',
    'ETFS 3x Long JPY Short GBP',
    '3',
    '3* Long vs. GBP',
    'GBP Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'JPYGBP',
    'MSFXSM Triple Long Japanese Yen/GBP Index (TR)',
    'ExposureShariah',
    'MSCEGJUL',
  ],
  [
    '2143',
    '976',
    '976',
    'ETFS 3x Long JPY Short USD',
    '3',
    '3* Long vs. USD',
    'USD Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'JPYUSD',
    'MSFXSM Triple Long Japanese Yen Index (TR)',
    'ExposureShariah',
    'MSCEJPUL',
  ],
  [
    '1955',
    '1019',
    '1020',
    'ETFS 2x Daily Long Lead',
    '2',
    'Lead',
    'Commodity ETCs',
    'Industrial Metals',
    'Lead',
    'Bloomberg Lead Subindex',
    'Industrial Metals',
    'BCOMPB',
  ],
  [
    '2056',
    '1019',
    '1020',
    'ETFS 1x Daily Short Lead',
    '-1',
    'Lead',
    'Commodity ETCs',
    'Industrial Metals',
    'Lead',
    'Bloomberg Lead Subindex',
    'Industrial Metals',
    'BCOMPB',
  ],
  [
    '1956',
    '1021',
    '1022',
    'ETFS 2x Daily Long Lean Hogs',
    '2',
    'Lean Hogs',
    'Commodity ETCs',
    'Agriculture',
    'Lean Hogs',
    'Bloomberg Lean Hogs Subindex',
    'NULL',
    'BCOMLH',
  ],
  [
    '2057',
    '1021',
    '1022',
    'ETFS 1x Daily Short Lean Hogs',
    '-1',
    'Lean Hogs',
    'Commodity ETCs',
    'Agriculture',
    'Lean Hogs',
    'Bloomberg Lean Hogs Subindex',
    'NULL',
    'BCOMLH',
  ],
  [
    '1957',
    '1023',
    '1024',
    'ETFS 2x Daily Long Live Cattle',
    '2',
    'Live Cattle',
    'Commodity ETCs',
    'Agriculture',
    'Live Cattle',
    'Bloomberg Live Cattle Subindex',
    'NULL',
    'BCOMLC',
  ],
  [
    '2058',
    '1023',
    '1024',
    'ETFS 1x Daily Short Live Cattle',
    '-1',
    'Live Cattle',
    'Commodity ETCs',
    'Agriculture',
    'Live Cattle',
    'Bloomberg Live Cattle Subindex',
    'NULL',
    'BCOMLC',
  ],
  [
    '1958',
    '1056',
    '1068',
    'ETFS 2x Daily Long Livestock',
    '2',
    'Livestock',
    'Commodity ETCs',
    'Agriculture',
    'Livestock',
    'Bloomberg Livestock Subindex',
    'NULL',
    'BCOMLI',
  ],
  [
    '2059',
    '1056',
    '1068',
    'ETFS 1x Daily Short Livestock',
    '-1',
    'Livestock',
    'Commodity ETCs',
    'Agriculture',
    'Livestock',
    'Bloomberg Livestock Subindex',
    'NULL',
    'BCOMLI',
  ],
  [
    '5',
    '9',
    'NULL',
    'Boost NASDAQ 100 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'NASDAQ 100',
    'NASDAQ-100® 3x Leveraged Notional Net Return',
    'NULL',
    'NULL',
  ],
  [
    '6',
    '10',
    'NULL',
    'Boost NASDAQ 100 3x Short Daily ETP',
    '-3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'NASDAQ 100',
    'NASDAQ-100® 3x Inverse Total Return',
    'NULL',
    'NULL',
  ],
  [
    '15',
    '14',
    'NULL',
    'Boost Natural Gas 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Natural Gas',
    'NASDAQ Commodity Natural Gas ER',
    'NULL',
    'NULL',
  ],
  [
    '10058',
    '1025',
    '1026',
    'ETFS 3x Daily Long Natural Gas',
    '3',
    'Oil & Gas',
    'Commodity ETCs',
    'Energy',
    'Natural Gas',
    'Bloomberg Natural Gas Subindex',
    'NULL',
    'BCOMNG',
  ],
  [
    '10085',
    '1025',
    '1026',
    'ETFS 2x Daily Long Natural Gas',
    '2',
    'Natural Gas',
    'Commodity ETCs',
    'Energy',
    'Natural Gas',
    'Bloomberg Natural Gas Subindex',
    'Energy',
    'BCOMNG',
  ],
  [
    '30',
    '14',
    'NULL',
    'Boost Natural Gas 2x Leverage Daily ETP',
    '2',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Natural Gas',
    'NASDAQ Commodity Natural Gas ER',
    'NULL',
    'NULL',
  ],
  [
    '2060',
    '1025',
    '1026',
    'ETFS 1x Daily Short Natural Gas',
    '-1',
    'Natural Gas',
    'Commodity ETCs',
    'Energy',
    'Natural Gas',
    'Bloomberg Natural Gas Subindex',
    'Energy',
    'BCOMNG',
  ],
  [
    '21',
    '14',
    'NULL',
    'Boost Natural Gas 2x Short Daily ETP',
    '-2',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Natural Gas',
    'NASDAQ Commodity Natural Gas ER',
    'NULL',
    'NULL',
  ],
  [
    '16',
    '14',
    'NULL',
    'Boost Natural Gas 3x Short Daily ETP',
    '-3',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Natural Gas',
    'NASDAQ Commodity Natural Gas ER',
    'NULL',
    'NULL',
  ],
  [
    '10057',
    '1025',
    '1026',
    'ETFS 3x Daily Short Natural Gas',
    '-3',
    'Oil & Gas',
    'Commodity ETCs',
    'Energy',
    'Natural Gas',
    'Bloomberg Natural Gas Subindex',
    'NULL',
    'BCOMNG',
  ],
  [
    '10060',
    '1027',
    '1028',
    'ETFS 3x Daily Long Nickel',
    '3',
    'Nickel',
    'Commodity ETCs',
    'Industrial Metals',
    'Nickel',
    'Bloomberg Nickel Subindex',
    'NULL',
    'BCOMNI',
  ],
  [
    '10086',
    '1027',
    '1028',
    'ETFS 2x Daily Long Nickel',
    '2',
    'Nickel',
    'Commodity ETCs',
    'Industrial Metals',
    'Nickel',
    'Bloomberg Nickel Subindex',
    'Industrial Metals',
    'BCOMNI',
  ],
  [
    '2061',
    '1027',
    '1028',
    'ETFS 1x Daily Short Nickel',
    '-1',
    'Nickel',
    'Commodity ETCs',
    'Industrial Metals',
    'Nickel',
    'Bloomberg Nickel Subindex',
    'Industrial Metals',
    'BCOMNI',
  ],
  [
    '10059',
    '1027',
    '1028',
    'ETFS 3x Daily Short Nickel',
    '-3',
    'Nickel',
    'Commodity ETCs',
    'Industrial Metals',
    'Nickel',
    'Bloomberg Nickel Subindex',
    'NULL',
    'BCOMNI',
  ],
  [
    '31',
    '22',
    'NULL',
    'Boost Palladium 2x Leverage Daily ETP',
    '2',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Palladium',
    'NASDAQ Commodity Palladium ER',
    'NULL',
    'NULL',
  ],
  [
    '25',
    '22',
    'NULL',
    'Boost Palladium 1x Short Daily ETP',
    '-1',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Palladium',
    'NASDAQ Commodity Palladium ER',
    'NULL',
    'NULL',
  ],
  [
    '10087',
    '1051',
    '1063',
    'ETFS 2x Daily Long Petroleum',
    '2',
    'Refined Products',
    'Commodity ETCs',
    'Energy',
    'Petroleum',
    'Bloomberg Petroleum Subindex',
    'Energy',
    'BCOMPE',
  ],
  [
    '2068',
    '1051',
    '1063',
    'ETFS 1x Daily Short Petroleum',
    '-1',
    'Refined Products',
    'Commodity ETCs',
    'Energy',
    'Petroleum',
    'Bloomberg Petroleum Subindex',
    'Energy',
    'BCOMPE',
  ],
  [
    '1962',
    '1029',
    '1030',
    'ETFS 2x Daily Long Platinum',
    '2',
    'Platinum',
    'Commodity ETCs',
    'Precious Metals',
    'Platinum',
    'Bloomberg Platinum Subindex',
    'Livestock',
    'BCOMPL',
  ],
  [
    '2069',
    '1029',
    '1030',
    'ETFS 1x Daily Short Platinum',
    '-1',
    'Platinum',
    'Commodity ETCs',
    'Precious Metals',
    'Platinum',
    'Bloomberg Platinum Subindex',
    'Livestock',
    'BCOMPL',
  ],
  [
    '1963',
    '1058',
    '1070',
    'ETFS 2x Daily Long Precious Metals',
    '2',
    'Diversified',
    'Commodity ETCs',
    'Precious Metals',
    'Precious Metals',
    'Bloomberg Precious Metals Subindex',
    'Livestock',
    'BCOMPR',
  ],
  [
    '2070',
    '1058',
    '1070',
    'ETFS 1x Daily Short Precious Metals',
    '-1',
    'Diversified',
    'Commodity ETCs',
    'Precious Metals',
    'Precious Metals',
    'Bloomberg Precious Metals Subindex',
    'Livestock',
    'BCOMPR',
  ],
  [
    '3',
    '7',
    'NULL',
    'Boost S&P 500 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'S&P 500',
    'S&P 500 Net Total Return',
    'NULL',
    'NULL',
  ],
  [
    '4',
    '8',
    'NULL',
    'Boost S&P 500 3x Short Daily ETP',
    '-3',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'S&P 500',
    'S&P 500 Total Return',
    'NULL',
    'NULL',
  ],
  [
    '89',
    '34',
    'NULL',
    'Boost S&P 500 VIX Short-Term Futures 2.25x Leverage Daily ETP',
    '2',
    'NULL',
    'Volatility ETCs',
    'Other Sectors',
    'S&P 500 VIX',
    'S&P 500 VIX Short-Term Futures ER',
    'NULL',
    'NULL',
  ],
  [
    '19',
    '15',
    'NULL',
    'Boost Silver 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Silver',
    'NASDAQ Commodity Silver ER',
    'NULL',
    'NULL',
  ],
  [
    '10062',
    '1031',
    '1032',
    'ETFS 3x Daily Long Silver',
    '3',
    'Silver',
    'Commodity ETCs',
    'Precious Metals',
    'Silver',
    'Bloomberg Silver Subindex',
    'NULL',
    'BCOMSI',
  ],
  [
    '32',
    '15',
    'NULL',
    'Boost Silver 2x Leverage Daily ETP',
    '2',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Silver',
    'NASDAQ Commodity Silver ER',
    'NULL',
    'NULL',
  ],
  [
    '1964',
    '1031',
    '1032',
    'ETFS 2x Daily Long Silver',
    '2',
    'Silver',
    'Commodity ETCs',
    'Precious Metals',
    'Silver',
    'Bloomberg Silver Subindex',
    'Livestock',
    'BCOMSI',
  ],
  [
    '2074',
    '1031',
    '1032',
    'ETFS 1x Daily Short Silver',
    '-1',
    'Silver',
    'Commodity ETCs',
    'Precious Metals',
    'Silver',
    'Bloomberg Silver Subindex',
    'Livestock',
    'BCOMSI',
  ],
  [
    '33',
    '15',
    'NULL',
    'Boost Silver 2x Short Daily ETP',
    '-2',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Silver',
    'NASDAQ Commodity Silver ER',
    'NULL',
    'NULL',
  ],
  [
    '20',
    '15',
    'NULL',
    'Boost Silver 3x Short Daily ETP',
    '-3',
    'NULL',
    'Commodity ETCs',
    'Other Sectors',
    'Silver',
    'NASDAQ Commodity Silver ER',
    'NULL',
    'NULL',
  ],
  [
    '10061',
    '1031',
    '1032',
    'ETFS 3x Daily Short Silver',
    '-3',
    'Silver',
    'Commodity ETCs',
    'Precious Metals',
    'Silver',
    'Bloomberg Silver Subindex',
    'NULL',
    'BCOMSI',
  ],
  [
    '1965',
    '1055',
    '1067',
    'ETFS 2x Daily Long Softs',
    '2',
    'Softs',
    'Commodity ETCs',
    'Agriculture',
    'Softs',
    'Bloomberg Softs Subindex',
    'Agriculture',
    'BCOMSO',
  ],
  [
    '2075',
    '1055',
    '1067',
    'ETFS 1x Daily Short Softs',
    '-1',
    'Softs',
    'Commodity ETCs',
    'Agriculture',
    'Softs',
    'Bloomberg Softs Subindex',
    'Agriculture',
    'BCOMSO',
  ],
  [
    '1966',
    '1035',
    '1036',
    'ETFS 2x Daily Long Soybean Oil',
    '2',
    'Soybean Oil',
    'Commodity ETCs',
    'Agriculture',
    'Soybean Oil',
    'Bloomberg Soybean Oil Subindex',
    'Agriculture',
    'BCOMBO',
  ],
  [
    '2076',
    '1035',
    '1036',
    'ETFS 1x Daily Short Soybean Oil',
    '-1',
    'Soybean Oil',
    'Commodity ETCs',
    'Agriculture',
    'Soybean Oil',
    'Bloomberg Soybean Oil Subindex',
    'Agriculture',
    'BCOMBO',
  ],
  [
    '1967',
    '1033',
    '1034',
    'ETFS 2x Daily Long Soybeans',
    '2',
    'Soybeans',
    'Commodity ETCs',
    'Agriculture',
    'Soybeans',
    'Bloomberg Soybeans Subindex',
    'Agriculture',
    'BCOMSY',
  ],
  [
    '2077',
    '1033',
    '1034',
    'ETFS 1x Daily Short Soybeans',
    '-1',
    'Soybeans',
    'Commodity ETCs',
    'Agriculture',
    'Soybeans',
    'Bloomberg Soybeans Subindex',
    'Agriculture',
    'BCOMSY',
  ],
  [
    '10064',
    '1037',
    '1038',
    'ETFS 3x Daily Long Sugar',
    '3',
    'Sugar',
    'Commodity ETCs',
    'Agriculture',
    'Sugar',
    'Bloomberg Sugar Subindex',
    'NULL',
    'BCOMSB',
  ],
  [
    '1968',
    '1037',
    '1038',
    'ETFS 2x Daily Long Sugar',
    '2',
    'Sugar',
    'Commodity ETCs',
    'Agriculture',
    'Sugar',
    'Bloomberg Sugar Subindex',
    'Agriculture',
    'BCOMSB',
  ],
  [
    '2078',
    '1037',
    '1038',
    'ETFS 1x Daily Short Sugar',
    '-1',
    'Sugar',
    'Commodity ETCs',
    'Agriculture',
    'Sugar',
    'Bloomberg Sugar Subindex',
    'Agriculture',
    'BCOMSB',
  ],
  [
    '10063',
    '1037',
    '1038',
    'ETFS 3x Daily Short Sugar',
    '-3',
    'Sugar',
    'Commodity ETCs',
    'Agriculture',
    'Sugar',
    'Bloomberg Sugar Subindex',
    'NULL',
    'BCOMSB',
  ],
  [
    '1969',
    '1039',
    '1040',
    'ETFS 2x Daily Long Tin',
    '2',
    'Tin',
    'Commodity ETCs',
    'Industrial Metals',
    'Tin',
    'Bloomberg Tin Subindex',
    'Industrial Metals',
    'BCOMSN',
  ],
  [
    '2079',
    '1039',
    '1040',
    'ETFS 1x Daily Short Tin',
    '-1',
    'Tin',
    'Commodity ETCs',
    'Industrial Metals',
    'Tin',
    'Bloomberg Tin Subindex',
    'Industrial Metals',
    'BCOMSN',
  ],
  [
    '28',
    '21',
    'NULL',
    'Boost TOPIX 2x Leverage Daily ETP',
    '2',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'TOPIX',
    'TOPIX TR',
    'NULL',
    'NULL',
  ],
  [
    '23',
    '21',
    'NULL',
    'Boost TOPIX 1x Short Daily ETP',
    '-1',
    'NULL',
    'Equity ETCs',
    'Other Sectors',
    'TOPIX',
    'TOPIX TR',
    'NULL',
    'NULL',
  ],
  [
    '1950',
    '1041',
    '1042',
    'ETFS 2x Daily Long Gasoline',
    '2',
    'Refined Products',
    'Commodity ETCs',
    'Energy',
    'Unleaded Gasoline',
    'Bloomberg Unleaded Gasoline Subindex',
    'Energy',
    'BCOMRB',
  ],
  [
    '2045',
    '1041',
    '1042',
    'ETFS 1x Daily Short Gasoline',
    '-1',
    'Refined Products',
    'Commodity ETCs',
    'Energy',
    'Unleaded Gasoline',
    'Bloomberg Unleaded Gasoline Subindex',
    'Energy',
    'BCOMRB',
  ],
  [
    '53',
    '28',
    'NULL',
    'Boost US Treasuries 10Y 3x Leverage Daily ETP',
    '3',
    'NULL',
    'Fixed Income ETCs',
    'Other Sectors',
    'US 10Yr Treasuries',
    'US Treasury Note 10y Rolling Future',
    'NULL',
    'NULL',
  ],
  [
    '41',
    '28',
    'NULL',
    'Boost US Treasuries 10Y 3x Short Daily ETP',
    '-3',
    'NULL',
    'Fixed Income ETCs',
    'Other Sectors',
    'US 10Yr Treasuries',
    'US Treasury Note 10y Rolling Future',
    'NULL',
    'NULL',
  ],
  [
    '68',
    '28',
    'NULL',
    'Boost US Treasuries 10Y 5x Short Daily ETP',
    '-5',
    'NULL',
    'Fixed Income ETCs',
    'Other Sectors',
    'US 10Yr Treasuries',
    'US Treasury Note 10y Rolling Future',
    'NULL',
    'NULL',
  ],
  [
    '110',
    '68',
    'NULL',
    'Boost US Treasuries 30Y 3x Short Daily ETP',
    '-3',
    'NULL',
    'Fixed Income ETCs',
    'Other Sectors',
    'US 30Yr Treasuries',
    'BNP Paribas US Treasury Ultra-Bond 30Y Rolling Future',
    'NULL',
    'NULL',
  ],
  [
    '2145',
    '977',
    '977',
    'ETFS 3x Short AUD Long USD',
    '-3',
    '3* Short vs. USD',
    'USD Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'USDAUD',
    'MSFXSM Triple Short Australian Dollar Index (TR)',
    'ExposureShariah',
    'MSCEAUUS',
  ],
  [
    '10027',
    '11274',
    '11274',
    'ETFS 5x Long USD Short EUR',
    '5',
    '5* Long vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'USDEUR',
    'MSFXSM 5X Long US Dollar/Euro Index (TR)',
    'ExposureShariah',
    'MSCEEUXL',
  ],
  [
    '2169',
    '821',
    '821',
    'ETFS 3x Long USD Short EUR',
    '3',
    '3* Long vs.EUR',
    'EUR Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'USDEUR',
    'MSFXSM Triple Long US Dollar/Euro Index(TR)',
    'ExposureShariah',
    'MSCEEUUL',
  ],
  [
    '2148',
    '979',
    '979',
    'ETFS 3x Short EUR Long USD',
    '-3',
    '3* Short vs. USD',
    'USD Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'USDEUR',
    'MSFXSM Triple Short Euro Index (TR)',
    'ExposureShariah',
    'MSCEERUS',
  ],
  [
    '10075',
    '11308',
    '11308',
    'ETFS 5x Long USD Short GBP',
    '5',
    '5* Long USD vs. GBP',
    'Long currency ETCs',
    'Leveraged (x5) and Short (x5) Currency Indices',
    'USDGBP',
    'MSFX 5x Long USDBritish Pound Index (TR)',
    'NULL',
    'MSCEGUXL',
  ],
  [
    '2150',
    '836',
    '836',
    'ETFS 3x Long USD Short GBP',
    '3',
    '3* Long vs. GBP',
    'GBP Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'USDGBP',
    'MSFXSM Triple Long US Dollar/GBP Index(TR)',
    'ExposureShariah',
    'MSCEGUUL',
  ],
  [
    '2146',
    '978',
    '978',
    'ETFS 3x Short GBP Long USD',
    '-3',
    '3* Short vs. USD',
    'USD Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'USDGBP',
    'MSFXSM Triple Short British Pound Index (TR)',
    'ExposureShariah',
    'MSCEGBUS',
  ],
  [
    '10076',
    '11309',
    '11309',
    'ETFS 5x Short USD Long GBP',
    '-5',
    '5* Short USD vs. GBP',
    'Short currency ETCs',
    'Leveraged (x5) and Short (x5) Currency Indices',
    'USDGBP',
    'MSFX 5x Short USDBritish Pound Index (TR)',
    'NULL',
    'MSCEGUXS',
  ],
  [
    '2147',
    '980',
    '980',
    'ETFS 3x Short JPY Long USD',
    '-3',
    '3* Short vs. USD',
    'USD Indices',
    'Leveraged (x3) and Short (x3) Currency Indices',
    'USDJPY',
    'MSFXSM Triple Short Japanese Yen Index (TR)',
    'ExposureShariah',
    'MSCEJPUS',
  ],
  [
    '10066',
    '1043',
    '1044',
    'ETFS 3x Daily Long Wheat',
    '3',
    'Wheat',
    'Commodity ETCs',
    'Agriculture',
    'Wheat',
    'Bloomberg Wheat Subindex',
    'NULL',
    'BCOMWH',
  ],
  [
    '10088',
    '1043',
    '1044',
    'ETFS 2x Daily Long Wheat',
    '2',
    'Wheat',
    'Commodity ETCs',
    'Agriculture',
    'Wheat',
    'Bloomberg Wheat Subindex',
    'Agriculture',
    'BCOMWH',
  ],
  [
    '2082',
    '1043',
    '1044',
    'ETFS 1x Daily Short Wheat',
    '-1',
    'Wheat',
    'Commodity ETCs',
    'Agriculture',
    'Wheat',
    'Bloomberg Wheat Subindex',
    'Agriculture',
    'BCOMWH',
  ],
  [
    '10065',
    '1043',
    '1044',
    'ETFS 3x Daily Short Wheat',
    '-3',
    'Wheat',
    'Commodity ETCs',
    'Agriculture',
    'Wheat',
    'Bloomberg Wheat Subindex',
    'NULL',
    'BCOMWH',
  ],
  [
    '1971',
    '1045',
    '1046',
    'ETFS 2x Daily Long Zinc',
    '2',
    'Zinc',
    'Commodity ETCs',
    'Industrial Metals',
    'Zinc',
    'Bloomberg Zinc Subindex',
    'Industrial Metals',
    'BCOMZS',
  ],
  [
    '2083',
    '1045',
    '1046',
    'ETFS 1x Daily Short Zinc',
    '-1',
    'Zinc',
    'Commodity ETCs',
    'Industrial Metals',
    'Zinc',
    'Bloomberg Zinc Subindex',
    'Industrial Metals',
    'BCOMZS',
  ],
];
// product.ProductId, product.IndexUniverseId, ProductIndexUniverseId, ProductName, MultipleFactor,ProductCategoryName,
// ProductTypeName, ProductSectorName, UnderlyingExposureText, IndexName,Sector, BloombergTotalReturn

const assetClasses = [
  {
    name: 'Equities',
    groups: ['Thematic', 'Broad Market'],
  },
  {
    name: 'Commodities',
    groups: [
      'Broad Commodities',
      'Precious metals',
      'Industrial Metals',
      'Energy',
      'Agriculture',
    ],
  },
  {
    name: 'Currencies',
    groups: ['USD Pairs', 'EUR Pairs', 'GBP Pairs'],
  },
  {
    name: 'Fixed Income',
    groups: ['Sovereign Debt'],
  },
];

const all = {
  productList,
  assetClasses,
  underlyingList,
  countries,
};

export default all;
